<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card v-on:keyup.enter="buildNewSearch">
		<v-card-title>
			<h2>Wszystkie projekty realizowane w państwach akredytacji placówki przez inne podmioty</h2>
		</v-card-title>
		<v-layout align-center justify-center row>
			<v-flex xs2>
				<v-text-field
					browser-autocomplete="off"
					class="ma-2"
					v-model="searchedFields.projectCode"
					label="Nr projektu"
					aria-label="project code"
					for="all-projects-by-agency-country-project-code"
					id="all-projects-by-agency-country-project-code"
				></v-text-field>
			</v-flex>
			<v-flex xs4>
				<v-text-field
					browser-autocomplete="off"
					class="ma-2"
					v-model="searchedFields.projectName"
					label="Nazwa projektu"
					aria-label="project name"
					for="all-projects-by-agency-country-project-name"
					id="all-projects-by-agency-country-project-name"
				></v-text-field>
			</v-flex>
			<v-flex xs3>
				<v-autocomplete
					clearable
					class="ma-2"
					v-model="searchedFields.contestName"
					label="Nazwa konkursu"
					aria-label="contest name"
					for="all-projects-by-agency-country-contest-name"
					id="all-projects-by-agency-country-contest-name"
					:items="contestNameList"
				></v-autocomplete>
			</v-flex>
		</v-layout>
		<v-layout align-center justify-center row>
			<v-flex xs3>
				<v-autocomplete
					clearable
					class="ma-2"
					v-model="searchedFields.bidderName"
					label="Nazwa oferenta"
					aria-label="bidder name"
					for="all-projects-by-agency-country-bidder-name"
					id="all-projects-by-agency-country-bidder-name"
					:items="bidderNameList"
				></v-autocomplete>
			</v-flex>
			<v-flex xs2>
				<v-autocomplete
					class="ma-2"
					v-model="searchedFields.countryId"
					:items="countryList"
					item-text="name"
					item-value="id"
					label="Kraj projektu"
					aria-label="project country"
					for="all-projects-by-agency-country-country-id"
					id="all-projects-by-agency-country-country-id"
					clearable
				></v-autocomplete>
			</v-flex>
			<v-flex xs4>
				<v-layout align-center justify-center>
					<v-btn @click="buildNewSearch" color="primary" dark class="ma-2">Szukaj</v-btn>
					<v-btn @click="resetSearch" color="primary" dark class="ma-2">Resetuj</v-btn>
					<v-btn @click="exportData" color="primary" dark class="ma-2">Eksportuj</v-btn>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-data-table
			:headers="headers"
			:rows-per-page-items="[10,20,25]"
			:items="projects"
			:pagination.sync="pagination"
			:total-items="itemCount"
			class="elevation-1">
			<template v-slot:items="props">
					<td>{{props.item.code}}</td>
					<td>{{props.item.name }}</td>
					<td>{{props.item.contestName}}</td>
					<td>
						<v-layout row>
							<v-flex shrink>
								{{ props.item.bidderName }}
							</v-flex>
							<v-flex v-if="props.item.mutualProject" pl-1 grow>
								<v-tooltip bottom>
									<template v-slot:activator="{ on }">
										<v-icon v-on="on">groups</v-icon>
									</template>
									<span>Projekt wspólny</span>
								</v-tooltip>
							</v-flex>
						</v-layout>
					</td>
					<td>{{props.item.country}}</td>
					<td>{{props.item.supervisorName}}</td>
					<td align="center">
						<v-icon v-if="!props.item.hideFromUser"
							small class="mr-2" @click="viewProject(props.item)" title="Podgląd">
							description
						</v-icon>
						<v-icon v-if="!props.item.hideFromUser"
							small class="mr-2" @click="viewProjectSummary(props.item)" title="Podsumowanie projektu">
							ballot
						</v-icon>
					</td>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	import {Api} from "@/api";
	import {Pagination} from "@/utils/PaginationUtils";
	import {AccreditationCountry} from "@/api/generated/AccreditationCountry";
	import {Project} from "@/api/generated/Project";
	import {ExportUtils} from "@/utils/ExportUtils";
  import {Filters} from "@/utils/Filters";

	export default {
		name: "AllProjectsByAgencyCountryView",

    mixins: [Filters],

		data() {
			return {
				headers: [
					{text: "Nr projektu", value: "projectCode", sortable: true},
					{text: "Nazwa projektu", value: "projectName", sortable: true},
					{text: "Nazwa konkursu", value: "contestName", sortable: true},
					{text: "Nazwa oferenta", value: "bidderName", sortable: true},
					{text: "Kraj realizacji projektu", value: "country", sortable: true},
					{text: "Opiekun projektu", value: "supervisorName", sortable: false},
					{text: "Akcje", align: "center", value: "action", sortable: false},
				],
				itemCount: 0,
				pagination: {
					rowsPerPage: 25,
					sortBy: null
				},
				projects: [],
				countryList: [],
				contestNameList: [],
				bidderNameList: [],
				search: "",
				searchedFields: Pagination.initSearchedFields([
					'projectCode',
					'projectName',
					'contestName',
					'bidderName',
					'countryId',
					'supervisorName'
				]),
			};
		},

		created () {
			this.getCountryList();
			this.getAllProjectContestNames();
			this.getAllProjectBidderNames();
		},

    mounted() {
      this.searchedFields = this.retrieveFilters(this.searchedFields);
      this.pagination = this.retrievePagination(this.pagination);
      this.buildNewSearch();
    },

		watch: {
			"pagination": {
				handler(pagination) {
					this.getItemList();
          this.paginationRef = pagination;
				},
				deep: true
			}
		},

		methods: {
			getItemList() {
				let sort = this.buildSort();
				Api.get(this,
					"/project-by-country/list?search=" + this.search
						+ "&page=" + this.pagination.page
						+ "&result=" + this.pagination.rowsPerPage
						+ "&sort=".concat(sort), response => {
							this.projects = response.itemList;
							this.itemCount = response.itemCount;
						});
			},

			buildNewSearch () {
				this.search = this.buildSearch();
				this.getItemList();
			},

			buildSearch () {
				return Pagination.buildSearchCriteria(this.searchedFields, false);
			},

			resetSearch () {
				Pagination.resetSearch(this.searchedFields);
				this.search = "";
				this.getItemList();
			},

			buildSort() {
				let order = this.pagination.descending === true ? "desc" : "asc";
				let columnName = this.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			exportData () {
				let search = this.search;
				let sort = this.buildSort();
				let endpointMainPath = "project-by-country";
				let path = "/" + endpointMainPath + "/export?search=" + search
					+ "&sort=".concat(sort);
				ExportUtils.sendExportRequest(path, this);
			},

			getCountryList () {
				AccreditationCountry.get(this, successResponse => {
						this.countryList = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować listy krajów", errorResponse);
					});
			},

			getAllProjectContestNames () {
				Project.getAllContestNamesByAgency(this, successResponse => {
						this.contestNameList = successResponse.sort();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować nazw konkursów", errorResponse);
					});
			},

			getAllProjectBidderNames () {
				Project.getAllBidderNamesByAgency(this, successResponse => {
						this.bidderNameList = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować nazw oferentów", errorResponse);
					});
			},

			viewProject(project) {
				this.$router.openInNewTab("/view/project/" + project.id);
			},

			viewProjectSummary(project) {
				this.$router.push("/app/project/" + project.id + "/summary");
			}
		},
	};
</script>

<style scoped>

</style>
